export default {"src":"/_next/static/media/pan.e1d5993a.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};